import reducer from "./menu";
import { actions, selectors } from "./menu";

export default reducer;
export { actions, selectors };
